import { useMemo } from 'react';
import { envLinks } from '../i18n/envLinks';
const getValidEnvKey = (env) => {
    return env in envLinks ? env : 'prod';
};
const useEnvLink = (link, environment, region) => {
    return useMemo(() => {
        const envKey = getValidEnvKey(environment);
        try {
            if (region !== 'ROW' && region in envLinks[envKey][link]) {
                return envLinks[envKey][link][region];
            }
            else {
                return envLinks[envKey][link]['UKI'];
            }
        }
        catch (error) {
            throw new Error(`ERROR in useEnvLink: can not get ${link} for ${envKey} for ${region}`);
        }
    }, [environment, link, region]);
};
// e.g: for Class-Components with no hook support
const envLinkFallback = (key, environment, region) => {
    try {
        return envLinks[getValidEnvKey(environment)][key][region];
    }
    catch (error) {
        throw new Error(`ERROR in useEnvLink: can not get ${key} for ${getValidEnvKey(environment)} for ${region}`);
    }
};
export { envLinks, useEnvLink, envLinkFallback };
